export default "__VITE_ASSET__BKCJleLe__"